import { useState } from "react";
import FooterTicker from "./FooterTicker";
import { IoMdClose } from "react-icons/io";
import ccLogo from "../../assets/logo/cc_logo.png";
// import spartanLogo from "../../assets/logo/spartan_logo.png";

const FooterHeader = ({ userLogin, handleInteraction }) => {
    const [showPopup, setShowPopup] = useState(false);

    const handleImageClick = () => {
        setShowPopup(!showPopup);
    };

    return (
        <>
            <div className="flex items-center gap-x-2 px-2 py-1 bg-[#333333]">
                <FooterTicker />
                <img
                    alt="logo"
                    src={ccLogo}
                    // onClick={!userLogin ? handleInteraction : handleImageClick}
                    // className="object-cover h-8 w-8 cursor-pointer border-2 border-[#38B6FF]"
                    className="object-cover h-8 w-8 cursor-pointer"
                />
            </div>
            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white text-black px-10 py-5 rounded shadow-lg relative">
                        <div className="flex flex-col gap-y-2">
                            <button
                                className="text-[12px] py-2 px-4 bg-black text-white rounded"
                            >
                                Coming Soon!
                            </button>
                        </div>
                        <IoMdClose
                            onClick={() => setShowPopup(false)}
                            className="absolute top-2 right-2 cursor-pointer"
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default FooterHeader